import { GetContextMenuItems } from 'ag-grid-community'
import { InflightNegotiations } from 'api'
import { Locale, Translation } from 'locale'
import { useCallback } from 'react'
import { useAppDispatch } from 'utils'
import { PinnedCollateralsThunks } from './PinnedCollateralsThunks'

export function useGridViewContextMenu() {
  const dispatch = useAppDispatch()

  const contextMenu = useCallback<GetContextMenuItems<InflightNegotiations>>(
    params => {
      const collateralId = params?.node?.data?.collateral?.id
      const pinnedCollaterals: string[] = params?.context?.userPreference?.pinnedCollaterals ?? []

      if (!collateralId) return []

      const index = pinnedCollaterals.findIndex(id => id === collateralId)

      return [
        {
          name: Locale.translate(Translation.TC_CONTEXT_MENU_PIN),
          disabled: index >= 0,
          action: () => {
            dispatch(PinnedCollateralsThunks.pin(collateralId))
          }
        },
        {
          name: Locale.translate(Translation.TC_CONTEXT_MENU_MOVE_TO_TOP),
          disabled: index === -1 || index === 0,
          action: () => {
            dispatch(PinnedCollateralsThunks.moveToTop(collateralId))
          }
        },
        {
          name: Locale.translate(Translation.TC_CONTEXT_MENU_MOVE_UP),
          disabled: index === -1 || index === 0,
          action: () => {
            dispatch(PinnedCollateralsThunks.moveUp(collateralId))
          }
        },
        {
          name: Locale.translate(Translation.TC_CONTEXT_MENU_MOVE_TO_BOTTOM),
          disabled: index === -1 || index === pinnedCollaterals.length - 1,
          action: () => {
            dispatch(PinnedCollateralsThunks.moveToBottom(collateralId))
          }
        },
        {
          name: Locale.translate(Translation.TC_CONTEXT_MENU_MOVE_DOWN),
          disabled: index === -1 || index === pinnedCollaterals.length - 1,
          action: () => {
            dispatch(PinnedCollateralsThunks.moveDown(collateralId))
          }
        },
        {
          name: Locale.translate(Translation.TC_CONTEXT_MENU_UNPIN),
          disabled: index === -1,
          action: () => {
            dispatch(PinnedCollateralsThunks.unpin(collateralId))
          }
        }
      ]
    },
    [dispatch]
  )

  return contextMenu
}
